import { createGlobalStyle } from 'styled-components';
import { maxMobile } from '../Utils/utilsStyle';

const GeneralStyleFeedTabs = createGlobalStyle`
  .feed-page-tabs {
    .heading-inner-page {
      .tips-placeholder  {
        margin-left: 275px;
        @media all and (max-width: ${maxMobile}) {
          margin-left: 0px;
        }
      }
    }
  }
`;

export default GeneralStyleFeedTabs;
